export * from './edit/Edit';
export * from './delete/Delete';
export * from './text/Text';
export * from './confirm/Confirm';
export * from './cancel/Cancel';



// WEBPACK FOOTER //
// ./src/components/buttons/index.js